"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modal = void 0;
const utilities_1 = require("./utilities");
const downloadElements = Array.from(document.querySelectorAll('[data-gs1-downloads]'));
const protectedDownloadLink = Array.from(document.querySelectorAll('.protected-download-link'));
const body = document.getElementsByTagName("body")[0];
let modalWrapperStart = `<div class="modal modal--downloads hidden" data-gs1-modal data-gs1-downloads-panel>
                            <div class="modal__inner">
                                <div class="modal__inner-text">`;
let modalWrapperEnd = `
                                </div>
                                <div class="modal__inner-icon"></div>
                            </div>
                        </div>`;
let loadingIndicator = `
                                    <div class="gs1-grid">
                                        <div class="row">
                                            <div class="col-md-4"></div>
                                            <div class="col-md-4"><div class="spinner circle"></div></div>
                                            <div class="col-md-4"></div>
                                        </div>
                                    </div>`;
exports.modal = modalWrapperStart + loadingIndicator + modalWrapperEnd;
if (downloadElements) {
    if (!document.querySelector('.modal--downloads')) {
        body.insertAdjacentHTML("beforeend", exports.modal);
    }
    const closestModal = document.querySelector('.modal--downloads');
    downloadElements.forEach((downloadElement) => {
        downloadElement.addEventListener("click", (event) => {
            event.preventDefault();
            const el = event.target;
            const anchor = event.target;
            (closestModal.classList.contains('hidden')) ? closestModal.classList.remove('hidden') : '';
            const documentBlocker = document.createElement('div');
            documentBlocker.remove();
            documentBlocker.classList.add('modal__blocker');
            document.querySelector('body').appendChild(documentBlocker);
            const downloadLink = anchor.href;
            try {
                (0, utilities_1.fetchPage)(downloadLink)
                    .then((data) => {
                    let getElements = new DOMParser();
                    //@ts-ignore
                    let element = getElements.parseFromString(data, 'text/html');
                    let downloadContent = (el.classList.contains('image-embed-item')) ? element.querySelector('.tx-gs1base-pi-dlwrapper') : element.querySelector('.tx-gs1downloads');
                    if (closestModal.children[0].children[0] && downloadContent) {
                        closestModal.children[0].children[0].innerHTML = downloadContent.innerHTML;
                    }
                }).catch(error => console.error(error));
            }
            catch (error) {
                console.error(`Failed to fetch ${downloadLink}`, error);
            }
        });
    });
}
if (protectedDownloadLink) {
    if (!document.querySelector('.modal--downloads')) {
        body.insertAdjacentHTML("beforeend", exports.modal);
    }
    const closestModal = document.querySelector('.modal--downloads');
    protectedDownloadLink.forEach((protectedDownload) => {
        protectedDownload.addEventListener("click", (event) => {
            event.preventDefault();
            const el = event.target;
            const anchor = (el.classList.contains('btn')) ? event.target : el.closest('a.protected-download-link');
            (closestModal.classList.contains('hidden')) ? closestModal.classList.remove('hidden') : '';
            const documentBlocker = document.createElement('div');
            documentBlocker.remove();
            documentBlocker.classList.add('modal__blocker');
            document.querySelector('body').appendChild(documentBlocker);
            const downloadLink = anchor.href;
            try {
                (0, utilities_1.fetchPage)(downloadLink)
                    .then((data) => {
                    let getElements = new DOMParser();
                    //@ts-ignore
                    let element = getElements.parseFromString(data, 'text/html');
                    let downloadContent = (el.classList.contains('image-embed-item') || el.classList.contains('btn')) ? element.querySelector('.tx-gs1base-pi-dlwrapper') : element.querySelector('.tx-gs1downloads');
                    if (closestModal.children[0].children[0] && downloadContent) {
                        closestModal.children[0].children[0].innerHTML = downloadContent.innerHTML;
                        let authorizeForm = $(closestModal).find('form[name="authorizeDownload"]');
                        if (authorizeForm) {
                            let $body = $('body');
                            $body.off('submit');
                            $body.on('submit', authorizeForm, function (event) {
                                event.preventDefault();
                                let formData = authorizeForm.serialize();
                                // Add loading indicator
                                closestModal.children[0].children[0].innerHTML = loadingIndicator;
                                $.ajax({
                                    type: 'post',
                                    url: authorizeForm.attr('action'),
                                    data: formData,
                                    cache: false,
                                    success: function (response) {
                                        let getElements = new DOMParser();
                                        //@ts-ignore
                                        let element = getElements.parseFromString(response, 'text/html');
                                        let downloadContent = (el.classList.contains('image-embed-item') || el.classList.contains('btn')) ? element.querySelector('.tx-gs1base-pi-dlwrapper') : element.querySelector('.tx-gs1downloads');
                                        if (closestModal.children[0].children[0] && downloadContent) {
                                            closestModal.children[0].children[0].innerHTML = downloadContent.innerHTML;
                                        }
                                    }
                                });
                                return false;
                            });
                        }
                    }
                }).catch(error => console.error(error));
            }
            catch (error) {
                console.error(`Failed to fetch: ${downloadLink}`, error);
            }
        });
    });
}
const downloadsPanels = Array.from(document.querySelectorAll('[data-gs1-downloads-panel]'));
downloadsPanels.forEach((downloadsPanel) => {
    downloadsPanel.addEventListener("click", (event) => {
        let currentTarget = event.target;
        if (currentTarget.classList.contains('modal--downloads') || currentTarget.classList.contains('modal__inner-icon')) {
            if (!downloadsPanel.classList.contains('hidden')) {
                downloadsPanel.classList.add('hidden');
            }
            const uiBlocker = document.querySelector('.modal__blocker');
            if (uiBlocker) {
                uiBlocker.addEventListener("click", (event) => {
                    if (!downloadsPanel.classList.contains('hidden')) {
                        downloadsPanel.classList.add('hidden');
                    }
                    uiBlocker.remove();
                    // Stop the browser from redirecting to the target file, if UI blocker is clicked
                    if (event.target) {
                        window.stop();
                    }
                });
                uiBlocker.remove();
            }
            // Stop redirecting to the target file, if the modal itself is clicked (not preventing the click on the actual
            // file link, if a user is impatient on re-click of a previously loaded, but closed, modal).
            if (event.target) {
                window.stop();
            }
            // Reset the panel
            let innerText = currentTarget.querySelector('.modal__inner-text');
            if (innerText) {
                innerText.innerHTML = '<div class="gs1-grid"><div class="row"><div class="col-md-4"></div><div class="col-md-4"><div class="spinner circle"></div></div><div class="col-md-4"></div></div></div>';
            }
        }
    });
});
